import videojs from 'expose-loader?videojs!video.js/dist/video.min.js';

const Plugin = videojs.getPlugin('plugin');


class MovieModePlugin extends Plugin {

  

  constructor(player, options) {
    super(player, options);

    if (options.customClass) {
      player.addClass(options.customClass);
    }

    let Button = videojs.getComponent('Button');
    var MovieModeButton = videojs.extend(Button, {
      constructor: function() {
        Button.apply(this, arguments);
        this.addClass('vjs-moviemode-button');
        this.controlText('Movie mode');
      },

      
      handleClick: function() {
        this.player().el().classList.toggle('vjs-movie-mode');
        this.el().classList.toggle('active');
      }
    });

    // videojs.registerComponent('movieModeBtn', MovieModeButton);
    
    
    player.on('ready', function() {
      let DButton = player.controlBar.addChild(new MovieModeButton(player, options), {});
      DButton.controlText(options.textControl);
      player.controlBar.el().insertBefore(DButton.el(), player.controlBar.getChild('fullscreenToggle').el());
    });

  }
}
videojs.registerPlugin('movieMode', MovieModePlugin);